import React, { Component } from "react";
import { Auth } from "aws-amplify";
import { Button, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
import Login from "../auth/views/Login";
import AuthModal from "../auth/AuthModal";
import "./assets/header.scss";
import helpmindlogo from "./assets/helpmindlogo.png";
import Hero from "./Hero";
import Crisis from "./Crisis";

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.session.isAuthenticated,
    showLoginPanel: state.root.showLoginPanel,
    user: state.session.user
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleLoginPanel: () => {
      console.log('dispatching login panel show');
      dispatch({ type: 'SHOW_LOGIN_PANEL', loginTabActive: true });
    },
    clearSession: () => {
      console.log('clearing user session');
      dispatch({ type: 'LOGOUT_USER_SUCCESS' });
    }
  }
}

class Header extends Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  handleLogout = async event => {
    console.log('logging out...');
    await Auth.signOut();
    this.props.clearSession();
    console.log('logged out: ', this.props);
  }

  render() {
    const isAuthenticated = this.props.isAuthenticated;
    const showLoginPanel = this.props.showLoginPanel;
    const user = this.props.user;
    let account;

    if (isAuthenticated && user) {

      account =
        <NavDropdown
          className="p-2 text-dark my-account"
          eventKey={5}
          title={<span className="fas fa-user min-width-3 text-center mr-2">{user.attributes.name}</span>}
          id="nav-dropdown">
          <Nav.Link eventKey={5.1} onClick={this.handleLogout}>
            <span className="fas fa-sign-out-alt min-width-3 text-center mr-2" />
            Logout
          </Nav.Link>
        </NavDropdown>
    } else {
      account =
        <Nav.Item as="li">
          <Nav.Link eventKey={5} onClick={this.props.toggleLoginPanel.bind(this)}>
            <span className="fas fa-user min-width-3 text-center mr-2" />
            Login/Register
          </Nav.Link>
        </Nav.Item>
    }
    return (
      <div className="container-fluid">
        <header className="container">
          <AuthModal showLoginPanel={showLoginPanel} />
          <div className="row">

            <Navbar collapseOnSelect expand="lg" className="my-2 my-md-0 mr-md-3" as="ul">
              <Navbar.Brand href="/">
                <img
                  src={helpmindlogo}
                  className="d-inline-block align-top"
                  alt="help my mind"
                  height="50"
                />
                <span className="hidden-xs">Help My Mind</span>
              </Navbar.Brand>

              <Navbar.Toggle className="pull-right" aria-controls="responsive-navbar-nav" />
              <Navbar.Collapse>
                <Nav className="mr-auto pull-right">
                  <Nav.Item as="li">
                    <Nav.Link eventKey={1} href="/advice">Advice</Nav.Link>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <Nav.Link eventKey={2} href="/stories">Stories</Nav.Link>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <Nav.Link eventKey={3} href="/resources">Resources</Nav.Link>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <Nav.Link eventKey={4} href="/games">Games</Nav.Link>
                  </Nav.Item>
                  {account}
                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </div>
        </header>
        <Hero props={this.props} />
        <Crisis props={this.props} />
        <div className="arrow-down"></div>
      </div >
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/containers/header/Header.js